import { globalFetch } from './globalActions';
import { AVATARS_HAS_ERRORED, AVATARS_IS_LOADING, AVATARS_FETCH_DATA_SUCCESS } from './types';

///////////
// Avatar Feeds //
///////////

  export function fetchAvatarsSuccess(itemObj) {
	const items = itemObj.avatars;
	let res = [];
	if (items && Object.keys(items).length > 0) {
		for (let i = 0; i < items.length; i++) {
			  res.push({
				c_text: items[i].cy_altText,
				e_text: items[i].en_altText,
				value: items[i].fileName,
				fileName: items[i].fileName,
				fileNameLarge: items[i].fileNameLarge,
				image: { avatar: true, src: items[i].fileName },
			  }); 
		}
	}
	return {
		type: AVATARS_FETCH_DATA_SUCCESS,
		payload: res
	};
}

export function fetchAvatars() {
	return globalFetch({
			urlPath: `avatars`,
			urlSrc: 3,
			reducerIsLoading: AVATARS_IS_LOADING,
			reducerError: AVATARS_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
				dispatch(fetchAvatarsSuccess(itemObj));
			}, isAlreadyInState: (getState) => {
				return getState().avatarItems && getState().avatarItems.success && getState().avatarItems.success.length > 0 ? true : false;
			}
	});
}
